var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.lazySrc,"alt":_vm.title,"title":_vm.title},on:{"click":function($event){return _vm.retry()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }